module.exports = __webpack_public_path__ + "static/media/eyelashes.38c8c890.png";